export default {
    topics: [
        {
            title: ' Calculate ',
            href: 'sm-stock-Calculate.html',
            attributes: { 'data-id': 'sm-stock-Calculate' },
            menu: { hasChildren: false },
            tocID: 'sm-stock-Calculate-d66e3879',
            topics: [],
        },
    ],
};

